import { AxiosPromise } from 'axios-cad-nx';
import {
    ApiResultReleaseBackupUnitsResponse,
    ReleaseUnitsResource,
    UnitStateTransitionPermissionEnum,
} from '@mark43/cad-api';
import { useCallback } from 'react';
import { useApiClient } from '~/api-client';

export function useReleaseBackupUnitsApi(): (
    agencyEventId: number
) => AxiosPromise<ApiResultReleaseBackupUnitsResponse> {
    const apiClient = useApiClient();
    return useCallback(
        (agencyEventId: number) => {
            return apiClient.request<ReleaseUnitsResource.ReleaseBackupUnits>({
                method: 'POST',
                url: `release_units/backup/`,
                data: {
                    agencyEventId,
                    actingTransitioner: UnitStateTransitionPermissionEnum.DISPATCHER.name,
                },
            });
        },
        [apiClient]
    );
}
